import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Card, Chip, ChipRow, Label } from "@/components/kit";
import { TankCutaway } from "@/components/TankCutaway";
import { useT } from "@/lib/i18n";
import { EIGHTHS, PRODUCTS, eighthLabel, productColor, productName } from "@/lib/tank";

const STEPS = [["−1", -1], ["−⅛", -0.125], ["+⅛", 0.125], ["+1", 1]];

export function DropDetails({ s, patch, result }) {
  const [open, setOpen] = useState(false);
  const t = useT();
  const whole = Math.floor(s.startInches + 1e-8);
  const eighth = Math.round((s.startInches - whole) * 8) % 8;
  const step = (d) => patch({ startInches: Math.max(0, Math.round((s.startInches + d) * 8) / 8) });
  return (
    <Card testID="details-card">
      <button type="button" className="details-toggle" data-testid="details-toggle" onClick={() => setOpen((o) => !o)}>
        <span>{t("Eighths, grade, and the tank picture")}</span>
        {open ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
      </button>
      {open && (
        <div className="details-body">
          <div className="step-row">
            {STEPS.map(([l, d]) => (
              <button key={l} type="button" className="step-btn" data-testid={`step-${d}`} onClick={() => step(d)}>{l}</button>
            ))}
          </div>
          <div className="frac-row">
            {EIGHTHS.map((f, i) => (
              <Chip key={f} testID={`eighth-${i}`} active={eighth === i} onPress={() => patch({ startInches: whole + f })}>
                {i === 0 ? ".0" : eighthLabel(i)}
              </Chip>
            ))}
          </div>
          <Label>{t("Grade")}</Label>
          <ChipRow testID="product-row">
            {PRODUCTS.map((p) => (
              <Chip key={p.id} testID={`product-${p.tone}`} active={s.product === p.id} onPress={() => patch({ product: p.id })}>
                <span className="grade-dot" style={{ background: productColor(p.id) }} />{t(productName(p.id))}
              </Chip>
            ))}
          </ChipRow>
          <TankCutaway diameter={s.diameter} startInches={s.startInches} finalInches={result.finalInches}
            h90={result.h90} h95={result.h95} fluidColor={productColor(s.product)} />
        </div>
      )}
    </Card>
  );
}
